import React from "react";
import { Icon, Loader } from "semantic-ui-react";

function StatCard({ icon, value, label, loading, delta, linkText, onLinkClick }) {
  return (
    <div className="stat-card">
      <div className="stat-card__header">
        <div className="stat-card__icon-box">
          <Icon name={icon} />
        </div>
        <div className="stat-card__label">{label}</div>
      </div>
      <div className="stat-card__value">
        {loading ? <Loader active inline size="small" /> : value}
      </div>
      {delta && (
        <div className={`stat-card__delta stat-card__delta--${delta.direction}`}>
          <span className="stat-card__delta-arrow">
            {delta.direction === "down" ? "↓" : "↑"}
          </span>
          {" "}
          <span className="stat-card__delta-value">{delta.text}</span>
          {" "}
          <span className="stat-card__delta-label">{delta.vsLabel}</span>
        </div>
      )}
      <div className="stat-card__spacer" />
      <hr className="stat-card__divider" />
      {linkText && (
        <div className="stat-card__link" onClick={onLinkClick}>
          {linkText} →
        </div>
      )}
    </div>
  );
}

export default StatCard;
